<snelstart-ui-details
  [config]="detailsConfig"
  [entityId]="id"
  title="{{ this.dossierItem.title }}"
>
  <snelstart-ui-details-content>
    <snelstart-venture-fiscaal-feature-workflow-item [id]="id"></snelstart-venture-fiscaal-feature-workflow-item>
  </snelstart-ui-details-content>

  <snelstart-ui-details-buttons>
    <snelstart-ui-button type="primary"
                         [config]="configSave()"
    >Opslaan
    </snelstart-ui-button>
  </snelstart-ui-details-buttons>

</snelstart-ui-details>
